"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ({ id, name, firstName, lastName, userName, email, organizationName, }) => {
    if (name) {
        return name;
    }
    if (firstName && lastName) {
        return `${lastName}, ${firstName}`;
    }
    if (userName) {
        return userName;
    }
    if (email) {
        return email;
    }
    if (organizationName) {
        return organizationName;
    }
    return id;
};
//# sourceMappingURL=displayUser.js.map